<form [formGroup]="form" class="flex flex-col h-full">
    <app-dashboard-segmented-toggle
        formControlName="status"
        [options]="segmentedToggleOptions"
    ></app-dashboard-segmented-toggle>

    <div class="flex flex-col h-full">
        <app-grid-toolbar
            [gridApi]="gridApi"
            [options]="gridToolbarOptions"
        ></app-grid-toolbar>
        <div class="flex-grow">
            <ag-grid-angular
                [context]="context"
                [rowData]="rowData"
                [gridOptions]="gridOptions"
                (gridReady)="onGridReady($event)"
                class="ag-theme-quartz h-100p"
            >
            </ag-grid-angular>
        </div>
    </div>
</form>
